define("shared/components/shared/configurable-address-fields", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "later/utils/constants", "shared/utils/state-list", "@ember/template-factory"], function (_exports, _component, _object, _service, _utils, _component2, _constants, _stateList, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"later/utils/constants",0,"shared/utils/state-list",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="u--m__b u--block" data-test-id="address-fields" ...attributes>
    {{#if this.showLabel}}
      <label class="u--m__b__xs {{@qaClassInputLabel}}" data-test-id="shipping-address">{{this.label}}</label>
    {{/if}}
    {{#if this.showDescription}}
      <p class="u--text--sm u--text--light" data-test-id="address-tax-text">
        {{this.description}}
      </p>
    {{/if}}
  
    {{#if (and this.unsavedAddressNotFound @showErrors this.showSuggestion)}}
      <p class="u--text--danger u--m__tb__md" data-test-id="address-not-found-error">
        {{svg-jar "warning" class="o--icon o--icon--danger u--m__r__xs"}}
        {{t "errors.address.no_matches"}}
      </p>
    {{/if}}
  
    <div class="o--formWrapper u--m__b__xs" data-test-id="country-input">
      <Shared::AddressFields::Country
        @country={{this.country}}
        @field={{this.addressFieldKeys.COUNTRY}}
        @isDisabled={{@isDisabled}}
        @setSelectedCountry={{@setSelectedCountry}}
        @showErrors={{@showErrors}}
        @sortCommonCountriesFirst={{@sortCommonCountriesFirst}}
        @suggestions={{this.suggestedChanges}}
      />
    </div>
  
    {{#if @showFullForm}}
      {{! Address line 1 }}
      {{#if (gt this.displayFields.length 0)}}
        <div class="o--formWrapper u--m__b__xs" data-test-id="address-line-one-input">
          {{#let (get this.displayFields 0) as |config|}}
            <Shared::AddressFields::Item
              @emptyText={{config.emptyText}}
              @field={{config.field}}
              @invalidText={{config.invalidText}}
              @isDisabled={{@isDisabled}}
              @isRequired={{config.isRequired}}
              @placeHolder={{config.placeHolder}}
              @qaClass={{config.qaClass}}
              @setSuggestion={{@setSuggestion}}
              @showErrors={{@showErrors}}
              @showSuggestion={{this.showSuggestion}}
              @value={{get @values config.value}}
            />
          {{/let}}
        </div>
      {{/if}}
      {{#if (gt this.displayFields.length 1)}}
        {{! Address line 2 }}
        <div class="o--formWrapper u--m__b__xs">
          {{#let (get this.displayFields 1) as |config|}}
            <Shared::AddressFields::Item
              @emptyText={{config.emptyText}}
              @field={{config.field}}
              @invalidText={{config.invalidText}}
              @isDisabled={{@isDisabled}}
              @isRequired={{config.isRequired}}
              @placeHolder={{config.placeHolder}}
              @qaClass={{config.qaClass}}
              @setSuggestion={{@setSuggestion}}
              @showErrors={{@showErrors}}
              @showSuggestion={{this.showSuggestion}}
              @value={{get @values config.value}}
            />
          {{/let}}
        </div>
      {{/if}}
      <div class="u--row u--row--noCollapse">
        {{#if (gt this.displayFields.length 2)}}
          {{#let (get this.displayFields 2) as |config|}}
            <div class={{this.getInputColumnsClass config.field}}>
              <div class="o--formWrapper u--m__b__0">
                <Shared::AddressFields::Item
                  @country={{this.country}}
                  @emptyText={{config.emptyText}}
                  @field={{config.field}}
                  @invalidText={{config.invalidText}}
                  @isDisabled={{@isDisabled}}
                  @isRequired={{config.isRequired}}
                  @narrow={{@narrow}}
                  @placeHolder={{config.placeHolder}}
                  @qaClass={{config.qaClass}}
                  @setSelectedState={{@setSelectedState}}
                  @setSuggestion={{@setSuggestion}}
                  @showErrors={{@showErrors}}
                  @showSuggestion={{this.showSuggestion}}
                  @value={{get @values config.value}}
                />
              </div>
            </div>
          {{/let}}
        {{/if}}
        {{#if (gt this.displayFields.length 3)}}
          {{#let (get this.displayFields 3) as |config|}}
            <div class={{this.getInputColumnsClass config.field}}>
              <div class="o--formWrapper u--m__b__0">
                <Shared::AddressFields::Item
                  @country={{this.country}}
                  @emptyText={{config.emptyText}}
                  @field={{config.field}}
                  @invalidText={{config.invalidText}}
                  @isDisabled={{@isDisabled}}
                  @isRequired={{config.isRequired}}
                  @narrow={{@narrow}}
                  @placeHolder={{config.placeHolder}}
                  @qaClass={{config.qaClass}}
                  @setSelectedState={{@setSelectedState}}
                  @setSuggestion={{@setSuggestion}}
                  @showErrors={{@showErrors}}
                  @showSuggestion={{this.showSuggestion}}
                  @value={{get @values config.value}}
                />
              </div>
            </div>
          {{/let}}
        {{/if}}
        {{#if (gt this.displayFields.length 4)}}
          {{#let (get this.displayFields 4) as |config|}}
            <div class={{this.getInputColumnsClass config.field}}>
              <div class="o--formWrapper u--m__b__0">
                <Shared::AddressFields::Item
                  @country={{this.country}}
                  @emptyText={{config.emptyText}}
                  @field={{config.field}}
                  @invalidText={{config.invalidText}}
                  @isDisabled={{@isDisabled}}
                  @isRequired={{config.isRequired}}
                  @narrow={{@narrow}}
                  @placeHolder={{config.placeHolder}}
                  @qaClass={{config.qaClass}}
                  @setSuggestion={{@setSuggestion}}
                  @showErrors={{@showErrors}}
                  @showSuggestion={{this.showSuggestion}}
                  @value={{get @values config.value}}
                />
              </div>
            </div>
          {{/let}}
        {{/if}}
        {{#if this.hasSameLineEmptyErrors}}
          <div class="u--col__12">
            <span class="o--form__helpText is--error u--m__tb__xs">{{this.sameLineErrorText}}</span>
          </div>
        {{/if}}
      </div>
    {{/if}}
  </div>
  */
  {
    "id": "DqEpM6ob",
    "block": "[[[11,0],[24,0,\"u--m__b u--block\"],[24,\"data-test-id\",\"address-fields\"],[17,1],[12],[1,\"\\n\"],[41,[30,0,[\"showLabel\"]],[[[1,\"    \"],[10,\"label\"],[15,0,[29,[\"u--m__b__xs \",[30,2]]]],[14,\"data-test-id\",\"shipping-address\"],[12],[1,[30,0,[\"label\"]]],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showDescription\"]],[[[1,\"    \"],[10,2],[14,0,\"u--text--sm u--text--light\"],[14,\"data-test-id\",\"address-tax-text\"],[12],[1,\"\\n      \"],[1,[30,0,[\"description\"]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,1],[[30,0,[\"unsavedAddressNotFound\"]],[30,3],[30,0,[\"showSuggestion\"]]],null],[[[1,\"    \"],[10,2],[14,0,\"u--text--danger u--m__tb__md\"],[14,\"data-test-id\",\"address-not-found-error\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[28,[35,3],[\"errors.address.no_matches\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[14,\"data-test-id\",\"country-input\"],[12],[1,\"\\n    \"],[8,[39,4],null,[[\"@country\",\"@field\",\"@isDisabled\",\"@setSelectedCountry\",\"@showErrors\",\"@sortCommonCountriesFirst\",\"@suggestions\"],[[30,0,[\"country\"]],[30,0,[\"addressFieldKeys\",\"COUNTRY\"]],[30,4],[30,5],[30,3],[30,6],[30,0,[\"suggestedChanges\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,7],[[[41,[28,[37,5],[[30,0,[\"displayFields\",\"length\"]],0],null],[[[1,\"      \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[14,\"data-test-id\",\"address-line-one-input\"],[12],[1,\"\\n\"],[44,[[28,[37,7],[[30,0,[\"displayFields\"]],0],null]],[[[1,\"          \"],[8,[39,8],null,[[\"@emptyText\",\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@placeHolder\",\"@qaClass\",\"@setSuggestion\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[30,8,[\"emptyText\"]],[30,8,[\"field\"]],[30,8,[\"invalidText\"]],[30,4],[30,8,[\"isRequired\"]],[30,8,[\"placeHolder\"]],[30,8,[\"qaClass\"]],[30,9],[30,3],[30,0,[\"showSuggestion\"]],[28,[37,7],[[30,10],[30,8,[\"value\"]]],null]]],null],[1,\"\\n\"]],[8]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[41,[28,[37,5],[[30,0,[\"displayFields\",\"length\"]],1],null],[[[1,\"      \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[12],[1,\"\\n\"],[44,[[28,[37,7],[[30,0,[\"displayFields\"]],1],null]],[[[1,\"          \"],[8,[39,8],null,[[\"@emptyText\",\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@placeHolder\",\"@qaClass\",\"@setSuggestion\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[30,11,[\"emptyText\"]],[30,11,[\"field\"]],[30,11,[\"invalidText\"]],[30,4],[30,11,[\"isRequired\"]],[30,11,[\"placeHolder\"]],[30,11,[\"qaClass\"]],[30,9],[30,3],[30,0,[\"showSuggestion\"]],[28,[37,7],[[30,10],[30,11,[\"value\"]]],null]]],null],[1,\"\\n\"]],[11]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n\"],[41,[28,[37,5],[[30,0,[\"displayFields\",\"length\"]],2],null],[[[44,[[28,[37,7],[[30,0,[\"displayFields\"]],2],null]],[[[1,\"          \"],[10,0],[15,0,[28,[30,0,[\"getInputColumnsClass\"]],[[30,12,[\"field\"]]],null]],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n              \"],[8,[39,8],null,[[\"@country\",\"@emptyText\",\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@narrow\",\"@placeHolder\",\"@qaClass\",\"@setSelectedState\",\"@setSuggestion\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[30,0,[\"country\"]],[30,12,[\"emptyText\"]],[30,12,[\"field\"]],[30,12,[\"invalidText\"]],[30,4],[30,12,[\"isRequired\"]],[30,13],[30,12,[\"placeHolder\"]],[30,12,[\"qaClass\"]],[30,14],[30,9],[30,3],[30,0,[\"showSuggestion\"]],[28,[37,7],[[30,10],[30,12,[\"value\"]]],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[12]]]],[]],null],[41,[28,[37,5],[[30,0,[\"displayFields\",\"length\"]],3],null],[[[44,[[28,[37,7],[[30,0,[\"displayFields\"]],3],null]],[[[1,\"          \"],[10,0],[15,0,[28,[30,0,[\"getInputColumnsClass\"]],[[30,15,[\"field\"]]],null]],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n              \"],[8,[39,8],null,[[\"@country\",\"@emptyText\",\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@narrow\",\"@placeHolder\",\"@qaClass\",\"@setSelectedState\",\"@setSuggestion\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[30,0,[\"country\"]],[30,15,[\"emptyText\"]],[30,15,[\"field\"]],[30,15,[\"invalidText\"]],[30,4],[30,15,[\"isRequired\"]],[30,13],[30,15,[\"placeHolder\"]],[30,15,[\"qaClass\"]],[30,14],[30,9],[30,3],[30,0,[\"showSuggestion\"]],[28,[37,7],[[30,10],[30,15,[\"value\"]]],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[15]]]],[]],null],[41,[28,[37,5],[[30,0,[\"displayFields\",\"length\"]],4],null],[[[44,[[28,[37,7],[[30,0,[\"displayFields\"]],4],null]],[[[1,\"          \"],[10,0],[15,0,[28,[30,0,[\"getInputColumnsClass\"]],[[30,16,[\"field\"]]],null]],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n              \"],[8,[39,8],null,[[\"@country\",\"@emptyText\",\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@narrow\",\"@placeHolder\",\"@qaClass\",\"@setSuggestion\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[30,0,[\"country\"]],[30,16,[\"emptyText\"]],[30,16,[\"field\"]],[30,16,[\"invalidText\"]],[30,4],[30,16,[\"isRequired\"]],[30,13],[30,16,[\"placeHolder\"]],[30,16,[\"qaClass\"]],[30,9],[30,3],[30,0,[\"showSuggestion\"]],[28,[37,7],[[30,10],[30,16,[\"value\"]]],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[16]]]],[]],null],[41,[30,0,[\"hasSameLineEmptyErrors\"]],[[[1,\"        \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"o--form__helpText is--error u--m__tb__xs\"],[12],[1,[30,0,[\"sameLineErrorText\"]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@qaClassInputLabel\",\"@showErrors\",\"@isDisabled\",\"@setSelectedCountry\",\"@sortCommonCountriesFirst\",\"@showFullForm\",\"config\",\"@setSuggestion\",\"@values\",\"config\",\"config\",\"@narrow\",\"@setSelectedState\",\"config\",\"config\"],false,[\"if\",\"and\",\"svg-jar\",\"t\",\"shared/address-fields/country\",\"gt\",\"let\",\"get\",\"shared/address-fields/item\"]]",
    "moduleName": "shared/components/shared/configurable-address-fields.hbs",
    "isStrictMode": false
  });

  /**
   * @class Shared::AddressFields
   * @extends Component
   *
   * This component is collection of an address inputs for a user to enter their street address
   * On usage of this component, it needs to be wrapped in a form to handle saving or submission of the form
   *
   *  Required Arguments:
   * - [showErrors] (Boolean) used to determine if errors should be shown. Can be used so that errors are not visible on page load
   * - [state] (String) string text of state.
   * - [setSelectedCountry] (Action) handler that sets country when power select dropdown is changed
   * - [values]
   *
   * Optional Arguments:
   * - [label] (string) label text for address fields. Defaults to translation: "account.subscription.billing.address.title"
   * - [description] (string) description text for address fields. Defaults to translation: "account.subscription.billing.address.description"
   *  - [showDescription] (boolean) used to determine if description should be shown. Defaults to true
   *  - [narrow] (boolean) Use when the address is shown in a narrow area to ensure columns are collapsed on last line when dropdown shows for state
   *
   * Inline Usage with all options:
   * ```
   *<Shared::AddressFields
   *  @showErrors={{true}}
   *  @state={{"Kansas"}}
   *  @setSelectedCountry={{this.setSelectedCountry}}
   *  @setSelectedState={{this.setSelectedState}}
   *  @narrow={{true}}
   *  @values={{this.addressChangeset}}
   * />
   * ```
   */
  let SharedAddressFieldsComponent = _exports.default = (_class = class SharedAddressFieldsComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _defineProperty(this, "addressFieldKeys", _constants.ADDRESS_FIELD_KEYS);
    }
    get country() {
      return this.args.values.country;
    }
    get displayFields() {
      return this.formConfig.fields.filter(field => field.key !== 'country').map(_ref => {
        let {
          key
        } = _ref;
        return this.fieldConfig[key];
      });
    }
    get fieldConfig() {
      return {
        line1: {
          emptyText: this.intl.t('errors.address.empty.line_one'),
          field: this.addressFieldKeys.LINE_ONE,
          invalidText: this.intl.t('errors.address.invalid_line'),
          isRequired: this.requiredFields.includes(this.addressFieldKeys.LINE_ONE),
          placeHolder: this.formConfig.fields.find(field => field.key == 'line1')?.label,
          qaClass: 'qa--address_street',
          value: 'line1'
        },
        line2: {
          field: this.addressFieldKeys.LINE_TWO,
          invalidText: this.intl.t('errors.address.invalid_line'),
          isRequired: this.requiredFields.includes(this.addressFieldKeys.LINE_TWO),
          placeHolder: this.formConfig.fields.find(field => field.key == 'line2')?.label,
          qaClass: 'qa--address_unit',
          value: 'line2'
        },
        city: {
          field: this.addressFieldKeys.CITY,
          invalidText: this.intl.t('errors.address.invalid_city'),
          isRequired: this.requiredFields.includes(this.addressFieldKeys.CITY),
          placeHolder: this.formConfig.fields.find(field => field.key == 'city')?.label,
          qaClass: 'qa--address_city',
          value: 'city'
        },
        state: {
          field: this.addressFieldKeys.STATE,
          invalidText: this.invalidStateText,
          isRequired: this.requiredFields.includes(this.addressFieldKeys.STATE),
          placeHolder: this.formConfig.fields.find(field => field.key == 'state')?.label,
          qaClass: 'qa--address_state',
          value: 'state'
        },
        postalCode: {
          field: this.addressFieldKeys.POSTAL_CODE,
          invalidText: this.invalidPostalCodeText,
          isRequired: this.requiredFields.includes(this.addressFieldKeys.POSTAL_CODE),
          placeHolder: this.formConfig.fields.find(field => field.key == 'postalCode')?.label,
          qaClass: 'qa--address_zip',
          value: 'postalCode'
        }
      };
    }
    get label() {
      return this.args.label || this.intl.t('account.subscription.billing.address.title');
    }
    get description() {
      return this.args.description || this.intl.t('account.subscription.billing.address.description');
    }
    get showDescription() {
      return this.args.showDescription ?? true;
    }
    get showLabel() {
      return this.args.showLabel ?? true;
    }
    get showSuggestion() {
      return this.args.showSuggestion ?? true;
    }
    get formConfig() {
      return this.address.addressConfig(this.country);
    }

    // @returns {Object} - Record<string, string>
    get formConfigFieldLabelsMap() {
      return this.formConfig.fields.reduce((acc, field) => {
        acc[field.key] = field.label;
        return acc;
      }, {});
    }
    get sameLineErrorText() {
      const errorTranslations = Object.entries(this.emptyStatesSameLine)
      // eslint-disable-next-line no-unused-vars
      .filter(_ref2 => {
        let [_, value] = _ref2;
        return value;
      }).map(_ref3 => {
        let [key] = _ref3;
        return this.formConfigFieldLabelsMap[key];
      });
      if (errorTranslations.length > 0) {
        return this.intl.t('errors.address.empty.multi', {
          errors: errorTranslations.join(', ')
        });
      }
      return '';
    }
    get emptyStatesSameLine() {
      return {
        [this.addressFieldKeys.CITY]: this.isFieldRequiredAndEmpty(this.addressFieldKeys.CITY),
        [this.addressFieldKeys.STATE]: this.isFieldRequiredAndEmpty(this.addressFieldKeys.STATE),
        [this.addressFieldKeys.POSTAL_CODE]: this.isFieldRequiredAndEmpty(this.addressFieldKeys.POSTAL_CODE)
      };
    }
    get hasSameLineEmptyErrors() {
      return this.sameLineEmptyErrorsAmount > 0 && this.args.showErrors;
    }
    get invalidStateText() {
      const key = _constants.ADDRESS_COUNTRIES_WITH_STATE.includes(this.country) ? 'errors.address.invalid_state' : 'errors.address.invalid_province';
      return this.intl.t(key);
    }
    get invalidPostalCodeText() {
      const key = this.country === 'US' ? 'errors.address.invalid_zip_code' : 'errors.address.invalid_postal_code';
      return this.intl.t(key);
    }
    get sameLineEmptyErrorsAmount() {
      return Object.values(this.emptyStatesSameLine).filter(value => value).length;
    }
    get unsavedAddressNotFound() {
      return this.address.isUnsavedAddressNotFound;
    }
    get suggestedChanges() {
      return this.address.suggestedChanges;
    }
    get requiredFields() {
      //Note: The influencer form passes in an override for required fields.
      if (this.args.requiredFields) {
        return this.args.requiredFields;
      }
      return this.address.getRequiredFields(this.country);
    }
    getInputColumnsClass(field) {
      // Note: if showing state dropdown, and city, state, and field. City needs to show on it's own line.
      // Using the fieldIndex instead of checking 'city' the third field could potentially not be city (ex if
      // we add a state dropdown for Italy, which shows postal code before city and state)
      if ((0, _stateList.isCountryWithStateOptions)(this.country)) {
        // Note: checkout shows in a narrow area so we expand all fields to full width when dropdown present.
        if (this.args.narrow) return 'u--col__12 u--m__b__xs';
        const fieldIndex = this.displayFields.findIndex(f => f.value === field);
        if (fieldIndex === 2) {
          return 'u--col__12 u--m__b__xs';
        } else if (fieldIndex === 3 || fieldIndex === 4) {
          return 'u--col__6';
        }
      }
      return this.displayFields.length === 5 ? 'u--col__4' : 'u--col__6';
    }

    /**
     *
     * @param {string} field key of ADDRESS_FIELD_KEYS. Example: postalCode
     * @returns {boolean}
     */
    isFieldRequiredAndEmpty(field) {
      return this.requiredFields.includes(field) && !(0, _utils.isPresent)(this.args.values[field]);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "getInputColumnsClass", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "getInputColumnsClass"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SharedAddressFieldsComponent);
});